module.exports = __webpack_public_path__ + "img/gm.5bbf7b74.svg";